import { Directive, ElementRef, OnInit } from '@angular/core';

@Directive({
  selector: '[lm-list-search-form]',
  standalone: false
})
export class LMListSearchFormDirective implements OnInit {

  constructor(private elementRef: ElementRef) {}

  ngOnInit() {
    // console.log(this.elementRef)
  }
}
